export default "__VITE_ASSET__CkOM0ARt__"